module.exports = __webpack_public_path__ + "static/img/22-100.ff40a68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-slider/22-100.jpg
// module id = A5k5
// module chunks = 2